export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12910.4c9385c2.jpg";